import { observer } from 'mobx-react-lite';
import React from 'react';
import { VIDEOS_CONTENT_TYPE } from '../../../../architecture/constants/Media';
import { MediaTypes } from '../../../../architecture/enums/MediaType';
import { KnowledgebaseEntry } from '../../../../models/Knowledgebase/KnowledgebaseEntry';
import Files from './components/Files';

interface IProps {
  entry: KnowledgebaseEntry;
}

const Video: React.FC<IProps> = ({ entry }) => {
  return (
    <>
      <div className='title'></div>
      <p className='subtitle'>Select a video from your library:</p>
      <Files
        mediaType={MediaTypes.Video}
        entry={entry}
        mediaFiles={entry.mediaFiles.filter((media) =>
          VIDEOS_CONTENT_TYPE.includes(media.contentType)
        )}
      />
    </>
  );
};

export default observer(Video);
